export const CSPR_CLICK_PROVIDERS_NETWORKS_DIC = {
    "casper-wallet": "CASPER",
    "casperdash": "CASPER",
    "metamask-snap": "MUMBAI",
    "casper-signer": "CASPER",
  };